// extracted by mini-css-extract-plugin
export default {"modalZ":"100001","headerHeight":"80px","root":"RnITu","title":"AFPbt","inboxIcon":"NUCTO","imageContainer":"QLza4","unreadIndicator":"qJyuz","te":"P7yPW"};